// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__5bhB-","actionsCol":"EnrolledClinics_actionsCol__3JlTc"};